import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { screenSize } from '../../../globals';
import STSComponent from "../../STSComponent/STSComponent";
import { constants } from '../constants';

class SubjectChangesRow extends STSComponent {
  render () {
    const { itemData } = this.props
    const classNames = constants.subjectTitles.map(item => item.className)
    const values = Object.values(itemData)
    return <div className="subject-changes-row">
      {values.map((elem, k) => <Fragment key={k}>
        {window.innerWidth <= screenSize.extraSmall ? constants.subjectTitles[k].title : null}
        <div key={k} className={`subject-cell-${classNames[k]}`}>
          {Array.isArray(elem)
            ? elem.map((item, i) => <li key={i}>{item}</li>)
            : k === 0
              ? <Fragment>
                {elem}
                <div className="subject-show-detail">show detail</div>
              </Fragment>
              : elem}
        </div>
      </Fragment>
      )}
    </div>
  }

  static propTypes = {
    itemData: PropTypes.object
  }
}

export default SubjectChangesRow



// WEBPACK FOOTER //
// ./src/components/ManagementSubjectChanges/components/SubjectChangesRow.js